import { Box, CircularProgress, styled } from "@mui/material";

const ScreenLoadingStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
}));

const ScreenLoading = () => (
  <ScreenLoadingStyled>
    <CircularProgress />
  </ScreenLoadingStyled>
);

export default ScreenLoading;
